import {IPubCtx} from "/@lib@/wsp/wspMetaUi.js";
import {SRC} from "/@lib@/wsp/src.js";
import {ERROR} from "/@lib@/core/errorReport.js";
import {JSX} from "/@lib@/commons/xml/dom.js";
import {WSP} from "/@lib@/wsp/wsp.js";
import {Dataset, DatasetEntry, IControlAreaContext, InputChoiceArea} from "/@lib@/commons/areas.js";
import {IFormJsonisable} from "/@lib@/commons/forms.js";
import {MsgLabel, OMsgLabelInit} from "/@back@/commons/basis.js";


/** Propose une liste d'éléments sélectionnable issues des agents */
export class ModelingBlackListInputArea extends InputChoiceArea<IPubCtx & IControlAreaContext> {
	constructor(id: string, protected genCode: string, protected agenPath: string) {
		super(id, "checkbox");
		this.setDirection("vertical");
	}

	buildBody(ctx: IPubCtx & IControlAreaContext): HTMLElement {
		let elt = super.buildBody(ctx);
		if (this.getDescription(ctx)) elt.title = this.getDescription(ctx);
		return elt;
	}

	_buildControl(ctx: IPubCtx & IControlAreaContext, name: string): HTMLDivElement {
		const control = <div/> as HTMLDivElement;//;super._buildControl(ctx, name);
		if (!ctx.shortDesc) return control; //race cond (dû à async dans AREAS.applyLayout()).
		const msg = control.appendChild(<MsgLabel id="msg" î={{
			label: "Chargement en cours...",
			level: "info", icon: "/@skin@/modeling/views/pending.svg"
		} as OMsgLabelInit}/>) as MsgLabel

		const toogleAllChecked = (owner: HTMLDivElement, currentInput: HTMLInputElement) => {
			const targetValue = !currentInput.checked;
			owner.querySelectorAll("input").forEach(entry => {
				(entry as HTMLInputElement).checked = targetValue;
			})
		}

		var agtPath = SRC.refUri2AgtPath(ctx.shortDesc.srcUri);
		//agtPath est doublé pour créer le context racine "@@".
		const dialogPath = "/" + agtPath + "/" + agtPath + "/" + this.agenPath;
		try {
			WSP.fetchAskAgt(ctx.wsp, control, this.genCode, dialogPath).then(result => {
				try {
					const entries = result?.getElementsByTagName("entry");
					if (entries && entries.length) {
						const dataSet: Dataset<DatasetEntry<IPubCtx>> = {}
						for (let i = 0; i < entries.length; ++i) {
							const key = entries[i].getAttribute("key");
							const name = entries[i].getAttribute("name");
							dataSet[key] = {label: `[${key}] ${name}`};
						}
						this.setDataset(dataSet);
						const fieldset = super._buildControl(ctx, name);
						control.appendChild(fieldset);
						fieldset.querySelectorAll("input").forEach(entry => {
							//entry.addEventListener("dblclick", (ev) => {toogleAllChecked(fieldset, entry); ev.stopPropagation()});
						});
						fieldset.querySelectorAll("label").forEach(entry => {
							entry.addEventListener("dblclick", (ev) => {
								toogleAllChecked(fieldset, entry.previousElementSibling as HTMLInputElement);
								ev.stopPropagation();
								ev.preventDefault()
							});
						});

						(control as any)._isLoaded = true;
						(control as any as IFormJsonisable).extractJson((control as any)._toExtractValue);
						(control as any)._toExtractValue = null;
						msg.setCustomMsg(null);
					} else
						msg.setCustomMsg("Aucun", "info");
				} catch (e) {
					ERROR.report(e);
					msg.setCustomMsg("Chargement en erreur", "error");
				}
			})
		} catch (e) {
			ERROR.report(e);
			msg.setCustomMsg("Chargement en erreur", "error");
		}

		Object.assign(control, {
			fillJson: function (this: HTMLDivElement, parent: Jsonisable, root: Jsonisable) {
				if ((this as any)._isLoaded) {
					const skipList: string[] = [];
					this.querySelectorAll("input").forEach(entry => {
						if (!entry.checked) skipList.push(entry.getAttribute("value"))
					});
					parent[name] = skipList.join(" ");
				}

			},
			extractJson: function (this: HTMLDivElement, parent: Dict<any>) {
				if ((this as any)._isLoaded) {
					const skipList: string[] = parent[name]?.split(" ");
					this.querySelectorAll("input").forEach(entry => {
						(entry as HTMLInputElement).checked = !skipList || skipList.indexOf(entry.getAttribute("value")) == -1;
					});
				} else
					(this as any)._toExtractValue = parent;
			}
		} as IFormJsonisable);
		return control;
	}
}

